/*eslint-env jquery*/
import React, { Component } from 'react'
import { toastr } from 'react-redux-toastr'
import MySweetAlert from '../Shared/MySweetAlert'
import Loading from '../Shared/Loading'
import { classService } from '../../_services/class.service'
import Modal from 'react-responsive-modal'
import classStatuses from '../../_constants/classStatuses'
import classTypes from '../../_constants/classTypes'
import ClassStatusesSelect from '../Shared/ClassStatusesSelect'
import ClassTypesSelect from '../Shared/ClassTypesSelect'
import DateTimePicker from '../Shared/DateTimePicker'
import NumberFormat from 'react-number-format'
import PriceInput from '../Shared/PriceInput'
import moment from 'moment-jalaali' // Notice here !
import UnionSelectForAdmin from '../Shared/UnionSelectForAdmin'
import TeacherSelectForAdmin from '../Shared/TeacherSelectForAdmin'
import LessonSelectForAdmin from '../Shared/LessonSelectForAdmin'

// Import React Table
import matchSorter from 'match-sorter'
import ReactTable from 'react-table'
import 'react-table/react-table.css'
import { Input } from 'antd'

import { Formik, Field, getIn, ErrorMessage } from 'formik'
import * as Yup from 'yup'
import ErrorPopUp from '../Shared/ErrorPopUp'

import ReactSelect from 'react-select'
import SimpleValue from 'react-select-simple-value'
import PieChart from 'react-minimal-pie-chart'

export const Select = ({ options, value, ...props }) => (
  <SimpleValue options={options} value={value}>
    {simpleProps => <ReactSelect {...props} {...simpleProps} />}
  </SimpleValue>
)

function formatDefaultValue(e) {
  if (e !== '0001-01-01T00:00:00') {
    const momentValue = moment(e, 'YYYY-MM-DD HH:mm')
    if (momentValue.isValid()) {
      return momentValue.format('jYYYY/jMM/jDD HH:mm')
    }
  }
}

class Class extends Component {
  constructor(props, context) {
    super(props, context)

    this.state = {
      initialItems: [],
      data: [],
      modal: false,
      modalHeading: '',
      loading: true,
      confirmDeleteShow: false,
      deleteItemIndex: 0,
      model: { name: '' },
      pageSize: 0
    }
  }

  componentWillMount() {
    this.getData()
  }

  handleModalCreate = () => {
    this.setState({
      modalHeading: 'ثبت کلاس آموزشی جدید',
      modal: true,
      model: {
        name: '',
        lessonId: '',
        date: '',
        capacity: '',
        comment: '',
        classStatus: 0,
        classType: undefined,
        unionId: undefined,
        address: '',
        tell: '',
        teachers: []
      }
    })
  }

  handleModalEdit = id => {
    // this.setState({ loading: true });

    classService
      .getById(id)
      .then(res => {
        let m = res.data
        m['teachers'] = m.teachers.map(el => el.id)
        m['lessonId'] = m.lesson.id
        // console.log(m);
        this.setState({
          modal: true,
          model: m,
          loading: false,
          modalHeading: 'ویرایش کلاس آموزشی "' + m.name + '"'
        })
      })
      .catch(error => {
        // console.log(error);
        this.setState({ loading: false })
      })
  }

  handleModalHide = e => {
    var evt = e || window.event // IE compatibility
    if (evt.preventDefault) {
      evt.preventDefault()
    }
    this.setState({ modal: false })
  }

  handleSweetAlertHide = () => {
    this.setState({ confirmDeleteShow: false })
  }

  getData() {
    classService
      .getAll({})
      .then(res => {
        // console.log(res.data)
        var data = res.data
        var pageSize = data.length > 10 ? 10 : data.length
        this.setState({
          initialItems: data,
          pageSize: pageSize,
          data: data,
          loading: false,
          isSubmitting: false,
          modal: false
        })
      })
      .catch(error => {
        // console.log(error);
        this.setState({ loading: false })
      })
  }

  // handleError(error) {
  //     this.setState({ loading: false });
  //     // // toastr.warning('مشکلی پیش آمد', error);
  // }

  handleDelete = e => {
    let _model = this.state.data[e.target.dataset.index]

    this.setState({ confirmDeleteShow: true, model: _model })
  }

  handleConfirmDelete = () => {
    this.setState({ loading: true, confirmDeleteShow: false })

    classService
      .delete(this.state.model.id)
      .then(res => {
        toastr.success('حذف کلاس آموزشی', 'کلاس آموزشی با موفقیت حذف شد')
        this.getData()
      })
      .catch(error => {
        // console.log(error);
        this.setState({ loading: false })
      })
  }

  handleSubmit = values => {
    this.setState({ loading: true })
    // console.log(values);

    if (values.id) {
      // values["imagePath"] = undefined;
      values['createDate'] = undefined
      if (!values.image) {
        values['image'] = ''
      }

      // console.log(JSON.stringify(values));
      // var formData = convertToFormData(values)
      classService
        .edit(JSON.stringify(values))
        .then(res => {
          toastr.success(
            'ویرایش کلاس آموزشی',
            'کلاس آموزشی "' + values.name + '" با موفقیت ویرایش شد'
          )
          this.setState({ modal: false })
          this.getData()
        })
        .catch(error => {
          // console.log(error);
          this.setState({ loading: false })
        })
    } else {
      values['isActive'] = true
      values['classStatus'] = 0
      // console.log(JSON.stringify(values));
      // var formData = convertToFormData(values)
      classService
        .add(JSON.stringify(values))
        .then(res => {
          toastr.success(
            'ثبت کلاس آموزشی جدید',
            'کلاس آموزشی "' + values.name + '" با موفقیت ثبت شد'
          )
          this.setState({ modal: false })
          this.getData()
        })
        .catch(error => {
          // console.log(error);
          this.setState({ loading: false })
        })
    }
  }

  render() {
    const ValidationSchema = Yup.object().shape({
      startDateTime: Yup.string()
        .trim()
        .required('تاریخ برگزاری'),
      endDateTime: Yup.string()
        .trim()
        .required('تاریخ اتمام'),
      lessonId: Yup.string()
        .trim()
        .required('درس'),
      amount: Yup.string()
        .trim()
        .required('هزینه'),
      comment: Yup.string()
        .trim()
        .required('توضیحات'),
      capacity: Yup.string()
        .trim()
        .required('ظرفیت'),
      classType: Yup.string()
        .trim()
        .required('نوع کلاس'),
      classStatus: Yup.string()
        .trim()
        .required('وضعیت کلاس'),
      address: Yup.string()
        .trim()
        .required('آدرس'),
      teachers: Yup.array()
        .min(1, 'حداقل یک استاد')
        .required('اساتید')
    })
    const { model, loading, data } = this.state
    return (
      !loading && (
        <div>
          <div className="row table-container" style={{ marginTop: 0 }}>
            <ReactTable
              data={data}
              filterable
              previousText="صفحه قبل"
              nextText="صفحه بعد"
              loadingText="در حال بارگذاری ..."
              noDataText="نتیجه ای یافت نشد"
              pageText="صفحه"
              ofText="از"
              rowsText="تعداد نمایش"
              getTableProps={() => ({ style: { display: 'block' } })}
              defaultFilterMethod={(filter, row) =>
                String(row[filter.id]) === filter.value
              }
              columns={[
                {
                  Header: 'ردیف',
                  id: 'row',
                  maxWidth: 50,
                  filterable: false,
                  style: {
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  },
                  className: 'numberFa',
                  Cell: row => {
                    return row.index + 1
                  }
                },
                {
                  Header: 'نام کلاس آموزشی',
                  accessor: 'name',
                  id: 'name',
                  style: {
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  },
                  filterMethod: (filter, rows) =>
                    matchSorter(rows, filter.value, { keys: ['name'] }),
                  filterAll: true,
                  Filter: ({ onChange }) => (
                    <Input
                      placeholder=""
                      allowClear
                      onChange={event => onChange(event.target.value)}
                    />
                  ),
                  Cell: row =>
                    row.original.lesson ? row.original.lesson.name : ''
                },
                {
                  Header: 'تاریخ برگزاری',
                  accessor: d => d.startDateTime,
                  accessor: 'startDateTime',
                  id: 'startDateTime',
                  style: {
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  },
                  Cell: props => (
                    <span className="ltr">
                      {formatDefaultValue(props.original.startDateTime)}
                    </span>
                  ),
                  filterMethod: (filter, row) => {
                    // console.log(moment(filter.value, 'YYYY-MM-DD').format('YYYY-MM-DD'));
                    // console.log((row.startDateTime.split('T')[0]));

                    if (filter.value === null || filter.value === undefined) {
                      return true
                    }
                    return (
                      row.startDateTime.split('T')[0] ===
                      moment(filter.value, 'YYYY-MM-DD HH:mm').format(
                        'YYYY-MM-DD'
                      )
                    )
                  },
                  Filter: ({ onChange }) => (
                    <DateTimePicker
                      name="startDateTime"
                      showTimePicker={false}
                      onChange={event => onChange(event)}
                    />
                  )
                },
                {
                  Header: 'تاریخ اتمام',
                  accessor: 'endDateTime',
                  id: 'endDateTime',
                  style: {
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  },
                  filterMethod: (filter, rows) =>
                    matchSorter(rows, filter.value, { keys: ['endDateTime'] }),
                  filterAll: true,
                  Filter: ({ onChange }) => (
                    <Input
                      placeholder=""
                      allowClear
                      onChange={event => onChange(event.target.value)}
                    />
                  ),
                  Cell: props => (
                    <span className="ltr">
                      {formatDefaultValue(props.original.endDateTime)}
                    </span>
                  )
                },
                // {
                //     Header: "ظرفیت",
                //     accessor: "capacity",
                //     id: "capacity",
                //     style: { display: 'flex', alignItems: 'center', 'justifyContent': 'center' },
                //     className: "numberFa",
                //     filterMethod: (filter, rows) =>
                //         matchSorter(rows, filter.value, { keys: ["capacity"] }),
                //     filterAll: true,
                //     Filter: ({ onChange }) =>
                //         <Input placeholder="" allowClear onChange={event => onChange(event.target.value)} />
                // },
                {
                  Header: 'هزینه',
                  accessor: 'amount',
                  id: 'amount',
                  style: {
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  },
                  filterMethod: (filter, rows) =>
                    matchSorter(rows, filter.value, { keys: ['amount'] }),
                  filterAll: true,
                  Filter: ({ onChange }) => (
                    <Input
                      placeholder=""
                      allowClear
                      onChange={event => onChange(event.target.value)}
                    />
                  ),
                  Cell: props => (
                    <NumberFormat
                      thousandSeparator={true}
                      className="numberFa"
                      value={props.original.amount}
                      displayType="text"
                      suffix=" ریال"
                    />
                  )
                },
                {
                  Header: 'وضعیت کلاس',
                  accessor: d => d.classStatus,
                  id: 'classStatus',
                  style: {
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  },
                  Cell: props => (
                    <span>
                      {props.original.classStatus !== undefined &&
                      classStatuses.filter(
                        el => el.id === props.original.classStatus
                      )[0] !== undefined
                        ? classStatuses.filter(
                            el => el.id === props.original.classStatus
                          )[0].name
                        : ''}
                    </span>
                  ),
                  filterMethod: (filter, row) => {
                    // console.log((filter.value));
                    // console.log((row));

                    if (filter.value === null || filter.value === undefined) {
                      return true
                    }
                    return row.classStatus === filter.value
                  },
                  Filter: ({ onChange }) => (
                    <ClassStatusesSelect onChange={event => onChange(event)} />
                  )
                },
                {
                  Header: 'ظرفیت کلاس',
                  id: 'registerCount',
                  style: { display: 'flex', alignItems: 'center' },
                  className: 'numberFa',
                  filterable: false,
                  Cell: props => (
                    <div className="text-center" style={{ width: '100%' }}>
                      <div style={{ marginBottom: 10 }}>
                        <PieChart
                          data={[
                            {
                              title: 'تعداد ثبت نام',
                              value: props.original.registerCount,
                              color: '#547EF6'
                            },
                            {
                              title: 'ظرفیت باقی مانده',
                              value: props.original.remainingCount,
                              color: '#B3E4FB'
                            }
                          ]}
                          labelPosition={140}
                          startAngle={180}
                          lineWidth={20}
                          label
                          labelStyle={{
                            fontSize: '13px',
                            fontFamily: 'IranSans',
                            fill: '#121212'
                          }}
                          animate
                          style={{ height: '70px' }}
                        />
                      </div>
                      <span className="numberFa" style={{ fontSize: '12px' }}>
                        ظرفیت کلاس: {props.original.capacity}
                      </span>
                      {/* <span className="numberFa">تعداد ثبت نام: {props.original.registerCount}</span><br /><span className="numberFa">ظرفیت باقی مانده: {props.original.remainingCount}</span> */}
                    </div>
                  )
                },
                {
                  Header: 'ویرایش',
                  accessor: 'id',
                  style: {
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  },
                  sortable: false,
                  // filterable: false,
                  Filter: ({ filter, onChange }) => (
                    <a
                      onClick={this.handleModalCreate}
                      className="btn btn-primary react-table-add-btn">
                      <i className="mdi mdi-plus" />
                      افزودن کلاس آموزشی جدید
                    </a>
                  ),
                  Cell: row => (
                    <div>
                      <a
                        onClick={() => this.handleModalEdit(row.original.id)}
                        data-index={row.index}
                        className="btn btn-sm btn-simple btn-success bmd-ripple bmd-flat-btn"
                        rel="tooltip"
                        data-original-title="ویرایش">
                        <i data-index={row.index} className="mdi mdi-pencil" />
                      </a>

                      <a
                        onClick={this.handleDelete}
                        data-index={row.index}
                        className="btn btn-sm btn-simple btn-danger bmd-ripple bmd-flat-btn delete-btn"
                        data-original-title="حذف"
                        rel="tooltip">
                        <i data-index={row.index} className="mdi mdi-delete" />
                      </a>
                    </div>
                  )
                }
              ]}
              key={this.state.pageSize}
              defaultPageSize={this.state.pageSize}
              className="-striped -highlight"
            />
          </div>
          <Modal
            open={this.state.modal}
            onClose={this.handleModalHide}
            center
            classNames={{
              overlay: 'customOverlay',
              modal: 'customModal lg',
              closeButton: 'customModalCloseButton'
            }}>
            <Formik
              initialValues={model}
              onSubmit={(values, { setSubmitting }) => {
                // console.log(values);
                this.handleSubmit(values)
              }}
              validationSchema={ValidationSchema}>
              {props => {
                const {
                  values,
                  touched,
                  errors,
                  isSubmitting,
                  handleChange,
                  handleBlur,
                  setFieldValue,
                  handleSubmit
                } = props
                return (
                  <div className="row" style={{ position: 'relative' }}>
                    <div className="col-md-12">
                      <form onSubmit={handleSubmit}>
                        <div className="row">
                          <div className="form-inline">
                            <div className="col-md-6">
                              <label>نوع کلاس</label>
                              <ClassTypesSelect
                                required
                                name="classStatus"
                                defaultValue={values.classType}
                                onChange={val => {
                                  setFieldValue('classType', val)
                                }}
                              />
                              <ErrorMessage
                                component={ErrorPopUp}
                                name="classType"
                              />
                            </div>

                            <div className="col-md-6">
                              <label>وضعیت</label>
                              <ClassStatusesSelect
                                name="classStatus"
                                defaultValue={values.classStatus}
                                onChange={val => {
                                  setFieldValue('classStatus', val)
                                }}
                              />
                              <ErrorMessage
                                component={ErrorPopUp}
                                name="classStatus"
                              />
                            </div>

                            <div className="clearfix" />

                            <div className="col-md-12">
                              <label>اتحادیه</label>
                              <UnionSelectForAdmin
                                required
                                defaultValue={values.unionId}
                                onChange={val => {
                                  setFieldValue('unionId', val)
                                }}
                                style={{
                                  height: 40,
                                  background: '#fff',
                                  border: 'thin solid #b4b4b4',
                                  borderRadius: 7
                                }}
                              />
                              <ErrorMessage
                                component={ErrorPopUp}
                                name="unionId"
                              />
                            </div>

                            <div className="clearfix" />

                            <div className="col-md-12">
                              <label>نام کلاس آموزشی</label>
                              <LessonSelectForAdmin
                                required
                                defaultValue={
                                  values.lesson
                                    ? values.lesson.id
                                    : values.lessonId
                                }
                                onChange={val => {
                                  setFieldValue('lessonId', val)
                                }}
                                style={{
                                  height: 40,
                                  background: '#fff',
                                  border: 'thin solid #b4b4b4',
                                  borderRadius: 7
                                }}
                              />
                              <ErrorMessage
                                component={ErrorPopUp}
                                name="lessonId"
                              />
                            </div>

                            <div className="clearfix" />

                            <div className="col-md-12">
                              <label>اساتید</label>
                              <TeacherSelectForAdmin
                                required
                                defaultValue={values.teachers}
                                onChange={val => {
                                  setFieldValue('teachers', val)
                                }}
                                style={{
                                  height: 40,
                                  background: '#fff',
                                  border: 'thin solid #b4b4b4',
                                  borderRadius: 7
                                }}
                              />
                              <ErrorMessage
                                component={ErrorPopUp}
                                name="teachers"
                              />
                            </div>

                            <div className="col-md-6">
                              <label>ﺗﺎرﯾﺦ و ساعت برگزاری کلاس</label>
                              <DateTimePicker
                                name="startDateTime"
                                minDate={moment()}
                                defaultValue={values.startDateTime}
                                required
                                showTimePicker
                                onChange={val => {
                                  setFieldValue('startDateTime', val)
                                }}
                              />
                              <ErrorMessage
                                component={ErrorPopUp}
                                name="startDateTime"
                              />
                            </div>

                            <div className="col-md-6">
                              <label>ﺗﺎرﯾﺦ و ساعت اتمام کلاس</label>
                              <DateTimePicker
                                name="endDateTime"
                                minDate={
                                  values.startDateTime
                                    ? values.startDateTime
                                    : moment()
                                }
                                defaultValue={values.endDateTime}
                                required
                                showTimePicker
                                onChange={val => {
                                  setFieldValue('endDateTime', val)
                                }}
                              />
                              <ErrorMessage
                                component={ErrorPopUp}
                                name="endDateTime"
                              />
                            </div>

                            <div className="clearfix" />

                            <div className="col-md-4">
                              <label className="pull-right">ظرفیت</label>
                              <NumberFormat
                                isNumericString
                                allowNegative={false}
                                defaultValue={values.capacity}
                                name="capacity"
                                onChange={e => {
                                  setFieldValue('capacity', e.target.value)
                                }}
                                onBlur={handleBlur}
                                className={
                                  getIn(errors, 'capacity') &&
                                  getIn(touched, 'capacity')
                                    ? 'text-input numberFa has-error rtl'
                                    : 'text-input numberFa required rtl'
                                }
                              />
                              <ErrorMessage
                                component={ErrorPopUp}
                                name="capacity"
                              />
                            </div>

                            <div className="col-md-4">
                              <label className="pull-right">هزینه</label>
                              <PriceInput
                                name="amount"
                                value={values.amount}
                                onChange={val => [setFieldValue('amount', val)]}
                                className={
                                  getIn(errors, 'amount') &&
                                  getIn(touched, 'amount')
                                    ? 'text-input has-error rtl'
                                    : 'text-input required rtl'
                                }
                              />
                              <ErrorMessage
                                component={ErrorPopUp}
                                name="capacity"
                              />
                            </div>

                            <div className="col-md-4">
                              <label className="pull-right">تلفن</label>
                              <Field
                                type="text"
                                autoFocus
                                name="tels"
                                className={
                                  getIn(errors, 'tels') &&
                                  getIn(touched, 'tels')
                                    ? 'text-input has-error rtl'
                                    : 'text-input required rtl'
                                }
                              />
                              <ErrorMessage
                                component={ErrorPopUp}
                                name="tels"
                              />
                            </div>

                            <div className="col-md-12">
                              <label className="pull-right">آدرس</label>
                              <Field
                                name="address"
                                rows="7"
                                render={({ field }) => (
                                  <textarea
                                    {...field}
                                    value={values.address}
                                    className={
                                      getIn(errors, 'address') &&
                                      getIn(touched, 'address')
                                        ? 'textarea has-error rtl'
                                        : 'textarea required rtl'
                                    }
                                  />
                                )}
                              />
                              <ErrorMessage
                                component={ErrorPopUp}
                                name="address"
                              />
                            </div>

                            <div className="col-md-12">
                              <label className="pull-right">توضیحات</label>
                              <Field
                                name="comment"
                                rows="7"
                                render={({ field }) => (
                                  <textarea
                                    {...field}
                                    value={values.comment}
                                    className={
                                      getIn(errors, 'comment') &&
                                      getIn(touched, 'comment')
                                        ? 'textarea has-error rtl'
                                        : 'textarea required rtl'
                                    }
                                  />
                                )}
                              />
                              <ErrorMessage
                                component={ErrorPopUp}
                                name="comment"
                              />
                            </div>

                            {/* <div className="col-md-12">
                                                        <label className="pull-right">تصویر</label>
                                                        <PicUploaderLiner label="تصویر"
                                                            value={values.imagePath}
                                                            onChange={(val) => {
                                                                // console.log(val);
                                                                setFieldValue('image', val);
                                                            }}
                                                        />
                                                        <ErrorMessage component={ErrorPopUp} name="image" />
                                                    </div> */}

                            <div className="col-md-12">
                              <br />
                              <input
                                type="hidden"
                                name="id"
                                value={values.id}
                              />
                              <button
                                type="submit"
                                className={
                                  'icon button submit-btn ' +
                                  (isSubmitting ? 'isSubmitting' : '')
                                }
                                disabled={isSubmitting}>
                                ذخیره
                              </button>
                            </div>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                )
              }}
            </Formik>
          </Modal>

          <MySweetAlert
            show={this.state.confirmDeleteShow}
            onCancel={this.handleSweetAlertHide}
            onConfirm={this.handleConfirmDelete}
            title={'آیا از حذف این کلاس آموزشی مطمئن هستید؟'}
          />
          {this.state.loading ? <Loading /> : ''}
        </div>
      )
    )
  }
}

export default Class
